/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable eqeqeq */
import React, {useEffect, useState} from 'react';
import Select, { components } from 'react-select';
import Helpers from '../helpers';

import { ProductFormContext } from '../../../context/product-form-context';

const DropdownIndicator = props => {
	return (
		<components.DropdownIndicator {...props}>
			<svg width={'18'} height={'10'} viewBox={'0 0 18 10'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
				<path d={'M1 1L9 9L17 1'} stroke={'#003C77'} strokeWidth={'1.5'} strokeLinecap={'round'} strokeLinejoin={'round'} />
			</svg>
		</components.DropdownIndicator>
	);
};

export default function OptionGroupAsSelect({
	option,
	index: groupIndex,
	setFilter,
	setFilters,
	filters,
	placeholder,
}) {
	const {
		availabilityMap,
		product,
		variant,
		showErrors,
	} = React.useContext(ProductFormContext);

	const allOptionValues =	option.values;
	const availableOptionValues = Helpers.getAvailableOptionsWithinSelections(
		product,
		groupIndex,
		filters,
		availabilityMap
	);

	//	----------
	//	Pre-select OptionGroups containing only one 'available' option (which is based on 'filters' have already been applied)
	//	----------
	const thisOptionGroupAlreadyHasAFilter = !!filters[groupIndex];
	if (!thisOptionGroupAlreadyHasAFilter && availableOptionValues?.length === 1) {
		// console.log(group_index,available_option_values[0]);	//	Debugging Only
		setFilter(groupIndex, availableOptionValues[0]);
	}

	//	---------------
	//	Render Children
	//	---------------
	const options = allOptionValues.map((_v, i) => {
		// const selected = filters[groupIndex] == _v;
		const doesExist = Helpers.doesOptionExistWithinSelections(
			product,
			groupIndex,
			_v,
			filters
		);
		const isInStock = Helpers.isOptionInStockWithinSelections(
			product,
			groupIndex,
			_v,
			filters,
			availabilityMap
		);

		// const available = doesExist && isInStock;

		//	Don't render this option at all if it's not available.
		if (!doesExist) return null;

		// if (!isInStock) return {value: _v, label: _v, color: '#7795B6'};

		return (
			{value: _v, label: _v}
		);
	});

	const selectedLabel	= filters[groupIndex];
	const [hasSelectBeenClicked, setHasSelectBeenClicked] = useState(false);

	function handleClick(event) {
		const selectElement = event.value;
		setHasSelectBeenClicked(true);

		// const available = availableOptionValues.indexOf(selectElement) > -1;
		// const selected = filters[groupIndex] === selectElement;

		setFilter(groupIndex, selectElement);
	}

	//	Don't render anything if there are no options to place in the <select> element.
	// if (!availableOptionValues.length)	return null;

	// const classNames = [
	// 	'pdp-form__option-group',
	// 	!selectedLabel && showErrors ? 'error' : null,
	// ].join(' ');

	useEffect(() => {
		// console.log('variant', variant); // Debug
		// console.log('options', options); // Debug
		// console.log('availableOptionValues', availableOptionValues); // Debug
		// console.log('filters[groupIndex]', filters[groupIndex]); // Debug

		if (availableOptionValues.indexOf(filters[groupIndex]) !== -1) {
			return;
		}

		if (!availableOptionValues.length) {
			// This if prevents an infinitew loop when a direct link is used.
			// The variant can become null if a product option has no stock for
			// any of it's variants
			if (variant !== null && variant?.selectedOptions[groupIndex].value !== options[0]?.value) {
				// THis allows the user to select oos products
				setFilter(groupIndex, variant?.selectedOptions[groupIndex].value);
			} else if (options[0] === null) {
				// This condition happens when all products are oos and the user switches between parent
				// product options
				const defaultOption = options.find(_option => { return ![null, undefined].includes(_option); });
				setFilter(groupIndex, defaultOption.value);
			} else {
				// This set the first available option when switching parent values.
				setFilter(groupIndex, options[0]?.value);
			}
		}

		if (availableOptionValues.length) {
			if (variant === null) {
				// This sets the first available variant when switching parents
				setFilter(groupIndex, availableOptionValues[0]);
			} else {
				setFilter(groupIndex, filters[groupIndex]);
			}
		}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [variant]);

	const selectPlaceholder = placeholder || `Select ${ option.name === 'Format' ? 'Type' : option.name } `;

	// const colourStyles = {
	// 	option: (styles, {
	// 		data, isDisabled, isFocused, isSelected,
	// 	}) => {
	// 		const {color} = data;
	// 		return {
	// 			...styles,
	// 			color: color || (isDisabled
	// 				? color
	// 				: isSelected
	// 					? color
	// 					: isFocused
	// 						? color
	// 						: undefined),
	// 		};
	// 	},
	// };

	return (
		<div key={filters[groupIndex]} className={`pdp-form__option-group ${ !selectedLabel && showErrors ? 'error' : '' }`}>
			<Select
				className={'react-select'}
				classNamePrefix={'react-select'}
				components={{DropdownIndicator}}
				placeholder={selectPlaceholder}
				// eslint-disable-next-line react/jsx-no-bind
				onChange={handleClick}
				isSearchable={false}
				options={[{
					label: selectPlaceholder,
					options: options.filter(e => { return e !== null; }),
				}]}
				defaultValue={{
					value: '',
					label: filters[groupIndex] ?? selectPlaceholder,
				}}
				// styles={colourStyles}
			/>
			{!selectedLabel && showErrors && (
				<div className={`pdp-form__option-group-error`}>
					{`Please select a ${ option.name === 'Format' ? 'type' : option.name.toLowerCase() }`}
				</div>
			)}
		</div>

	);
}// function
